<button type="button"
        class="notification-trigger"
        [class.has-new-notification]="novedadesCount > 0"
        (click)="openRecent($event, recentPanel)"
        pTooltip="Notificaciones"
        tooltipPosition="bottom"
        [attr.aria-label]="'Abrir notificaciones. ' + novedadesCount + ' nuevas'">
    <i class="pi pi-bell"></i>
    <span *ngIf="novedadesCount > 0" class="notification-badge">{{ badgeText }}</span>
</button>

<p-toast #floatingToast
         [key]="floatingNotificationToastKey"
         position="bottom-left"
         styleClass="web-notification-toast"
         [preventOpenDuplicates]="true">
    <ng-template let-message pTemplate="message">
        <button type="button"
                class="floating-notification-card"
                (click)="openFloatingNotification(message)">
            <span class="floating-notification-icon">
                <i [class]="notificationIcon(message.data.codigo)"></i>
            </span>
            <span class="floating-notification-content">
                <strong>{{ notificationShortTitle(message.data) }}</strong>
                <span>{{ message.data.mensaje }}</span>
                <small>Haz clic para ver</small>
            </span>
        </button>
    </ng-template>
</p-toast>

<p-popover #recentPanel
                styleClass="notification-overlay"
                [appendTo]="'body'"
                (onShow)="onRecentPanelShow()">
    <div class="notification-panel">
        <div class="notification-panel-header">
            <strong>Notificaciones</strong>
            <div class="notification-panel-header-actions">
                <span>Recientes</span>
                <button type="button"
                        *ngIf="recentNotifications.length"
                        class="notification-clear-button"
                        pTooltip="Limpiar mi lista (el historial no se toca)"
                        tooltipPosition="bottom"
                        (click)="limpiarNotificaciones()">
                    <i class="pi pi-eraser"></i>
                    Limpiar
                </button>
            </div>
        </div>

        <div class="recent-notification-filters" role="group" aria-label="Filtrar notificaciones por tipo">
            <button type="button"
                    *ngFor="let type of recentNotificationTypes"
                    class="recent-notification-chip"
                    [class.is-active]="recentNotificationType === type.codigo"
                    [attr.aria-pressed]="recentNotificationType === type.codigo"
                    (click)="selectRecentNotificationType(type.codigo)">
                {{ type.nombre }}
            </button>
        </div>

        <button type="button"
                *ngIf="browserNotifications.canRequestPermission"
                class="browser-notification-cta"
                (click)="enableBrowserNotifications()">
            <i class="pi pi-desktop"></i>
            <span>Activar alertas del navegador</span>
        </button>

        <div *ngIf="browserNotifications.isBlocked" class="browser-notification-blocked">
            <i class="pi pi-ban"></i>
            <span>Las alertas del navegador están bloqueadas para este sitio.</span>
        </div>

        <div *ngIf="loadingRecent" class="notification-state">
            <i class="pi pi-spin pi-spinner"></i>
            <span>Cargando...</span>
        </div>

        <div *ngIf="!loadingRecent && !recentNotifications.length" class="notification-state">
            <i class="pi pi-inbox"></i>
            <span>No hay notificaciones.</span>
        </div>

        <div *ngIf="!loadingRecent && recentNotifications.length"
             class="notification-list"
             (scroll)="onRecentScroll($event)">
            <button type="button"
                    *ngFor="let notification of recentNotifications; trackBy: trackByNotificationId"
                    class="notification-item notification-item-compact"
                    [class.not-opened]="!notification.abierto"
                    (click)="markAsOpened(notification)">
                <div class="notification-item-icon">
                    <i [class]="notificationIcon(notification.codigo)"></i>
                </div>
                <div class="notification-item-content">
                    <div class="notification-title-row">
                        <div class="notification-title">{{ notificationShortTitle(notification) }}</div>
                    </div>
                    <div class="notification-message-top-10">{{ notification.mensaje }}</div>
                    <div class="notification-order-number">
                        {{ notification.createdOn | date:'dd/MM/yyyy HH:mm' }}
                    </div>
                </div>
            </button>
            <div *ngIf="loadingRecentMore" class="notification-loading-more">
                <i class="pi pi-spin pi-spinner"></i>
                <span>Cargando más...</span>
            </div>
        </div>

        <button type="button" class="history-button" (click)="openHistory(recentPanel)">
            Ver historial completo
            <i class="pi pi-arrow-right"></i>
        </button>
    </div>
</p-popover>

<p-dialog closeAriaLabel="Cerrar" header="Historial de notificaciones"
          [(visible)]="historyVisible"
          [modal]="true"
          [draggable]="false"
          [resizable]="false"
          [appendTo]="'body'"
          [style]="{width: '680px'}"
          [breakpoints]="{'768px': '95vw'}">
    <div class="history-filters">
        <div class="history-filter-field">
            <label for="notificationType">Tipo de notificación</label>
            <p-select inputId="notificationType"
                        [(ngModel)]="historyNotificationType"
                        [options]="historyNotificationTypes"
                        optionLabel="nombre"
                        optionValue="codigo"
                        [showClear]="true"
                        appendTo="body"
                        placeholder="Todos los tipos"
                        (onChange)="onHistoryNotificationTypeChange()">
            </p-select>
        </div>
        <div class="history-filter-field">
            <label for="notificationDateFrom">Desde</label>
            <p-datepicker inputId="notificationDateFrom"
                        [(ngModel)]="historyDateFrom"
                        (ngModelChange)="onHistoryDateChange()"
                        [showIcon]="true"
                        [showButtonBar]="true"
                        [maxDate]="historyDateTo"
                        appendTo="body"
                        dateFormat="dd/mm/yy"
                        placeholder="dd/mm/aaaa">
            </p-datepicker>
        </div>
        <div class="history-filter-field">
            <label for="notificationDateTo">Hasta</label>
            <p-datepicker inputId="notificationDateTo"
                        [(ngModel)]="historyDateTo"
                        (ngModelChange)="onHistoryDateChange()"
                        [showIcon]="true"
                        [showButtonBar]="true"
                        [minDate]="historyDateFrom"
                        appendTo="body"
                        dateFormat="dd/mm/yy"
                        placeholder="dd/mm/aaaa">
            </p-datepicker>
        </div>
        <div class="history-filter-field history-filter-checkbox">
            <label for="notificationSoloNoAtendidas">Estado</label>
            <div class="history-filter-checkbox-control">
                <p-checkbox inputId="notificationSoloNoAtendidas"
                            [(ngModel)]="historySoloNoAtendidas"
                            [binary]="true"
                            (onChange)="onHistorySoloNoAtendidasChange()">
                </p-checkbox>
                <label for="notificationSoloNoAtendidas">Solo no atendidas</label>
            </div>
        </div>
        <div class="history-filter-actions">
            <button type="button"
                    pButton
                    icon="pi pi-times"
                    class="p-button-outlined p-button-secondary"
                    pTooltip="Limpiar filtros"
                    tooltipPosition="top"
                    aria-label="Limpiar filtros"
                    (click)="clearHistoryFilters()">
            </button>
        </div>
    </div>

    <div *ngIf="!loadingHistory" class="history-results-summary">
        {{ historyTotal }} {{ historyTotal === 1 ? 'notificación' : 'notificaciones' }}
    </div>

    <div *ngIf="loadingHistory" class="notification-state history-state">
        <i class="pi pi-spin pi-spinner"></i>
        <span>Cargando historial...</span>
    </div>

    <div *ngIf="!loadingHistory && !historyNotifications.length" class="notification-state history-state">
        <i class="pi pi-inbox"></i>
        <span>No hay notificaciones.</span>
    </div>

    <div *ngIf="!loadingHistory && historyNotifications.length" class="notification-list history-list">
        <button type="button"
                *ngFor="let notification of historyNotifications; trackBy: trackByNotificationId"
                class="notification-item"
                [class.not-opened]="!notification.abierto"
                (click)="markAsOpened(notification)">
            <div class="notification-item-icon">
                <i [class]="notificationIcon(notification.codigo)"></i>
            </div>
            <div class="notification-item-content">
                <div class="notification-title-row">
                    <div class="notification-title">{{ notificationShortTitle(notification) }}</div>
                </div>
                <div class="notification-message">{{ notification.mensaje }}</div>
                <div class="notification-meta">
                    {{ notification.createdOn | date:'dd/MM/yyyy HH:mm' }}
                </div>
            </div>
        </button>
    </div>

    <p-paginator *ngIf="historyTotal > historyPageSize"
                 [first]="historyPage * historyPageSize"
                 [rows]="historyPageSize"
                 [totalRecords]="historyTotal"
                 [showCurrentPageReport]="true"
                 currentPageReportTemplate="{first} - {last} de {totalRecords}"
                 (onPageChange)="onHistoryPageChange($event)">
    </p-paginator>
</p-dialog>
